import React from 'react';
import { useNavigate } from 'react-router-dom';
import useFavicon from '../hooks/useFavicon';

const NotFound = () => {
  useFavicon('/logo-main.png');
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-nm-light flex items-center justify-center p-4">
      <div className="max-w-md w-full nm-flat-light p-12 rounded-3xl border-transparent text-center">
        <div className="text-9xl font-bold text-[#C6A25E] mb-4 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.05)]">404</div>
        <h1 className="text-3xl font-bold text-[#0B1C2D] mb-4">Page Not Found</h1>
        <p className="text-slate-600 mb-8 font-light">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center nm-button-light text-[#0B1C2D] px-6 py-3 rounded-xl font-bold border-transparent active:scale-95 transition-all cursor-pointer"
          >
            ← Back
          </button>
          <a
            href="/"
            className="inline-flex items-center justify-center nm-button-light text-[#C6A25E] px-6 py-3 rounded-xl font-bold border-transparent active:scale-95 transition-all cursor-pointer"
          >
            Go Back Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;